import { RefundPurchasesModel } from 'api-hooks/order/common';
import { RefundSalesModel } from 'api-hooks/sale/common';
import { NavigationRoutes } from 'common/constants';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import useDate from 'hooks/use-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: (RefundPurchasesModel | RefundSalesModel)[];
}

export default function SalePurchaseRefundTable(props: Props) {
  const { t } = useTranslation();
  const { data } = props;

  const formatDate = useDate();

  const columns = React.useMemo<
    IColumn<RefundPurchasesModel | RefundSalesModel>[]
  >(
    () => [
      {
        header: t('common:refund'),
        accessorKey: 'number',
        minSize: 180,
      },
      {
        header: t('common:created_at'),
        accessorKey: 'requestedAt',
        minSize: 150,
        cell: ({ getValue }) =>
          getValue() ? formatDate(getValue() as Date, 'dd MMM yyyy') : '-',
      },
      {
        header: t('common:total'),
        accessorKey: 'amount',
        minSize: 150,
        cell: ({ getValue }) => `Rp ${string2money(getValue() as string)}`,
        isNumber: true,
      },
    ],
    [formatDate, t],
  );

  return (
    <>
      <TableComponent
        columns={columns}
        data={data}
        headerColor={stylesColors.bg1}
        rowLink={(row) => {
          return {
            pathname: NavigationRoutes.RefundView,
            query: {
              id: row.original?.refundId,
            },
          };
        }}
      />
      <Separator gap={16} />
    </>
  );
}
